// extracted by mini-css-extract-plugin
module.exports = {"stat":"styles_stat__wlpn3"};